import { render, staticRenderFns } from "./AdCampaignList.vue?vue&type=template&id=32b8a5e0&scoped=true"
import script from "./AdCampaignList.vue?vue&type=script&lang=js"
export * from "./AdCampaignList.vue?vue&type=script&lang=js"
import style0 from "./AdCampaignList.vue?vue&type=style&index=0&id=32b8a5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b8a5e0",
  null
  
)

export default component.exports